import { useState } from 'react';
import { SuccessController } from './interfaces';

export const useSuccessController = (): SuccessController => {
    return {};
};
